import axios from 'axios';

// 1. TỐI ƯU: Sử dụng biến môi trường cho linh hoạt giữa Dev và Prod
//const API_BASE_URL = 'http://localhost:8000/api';
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const client = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 2. SỬA LỖI HOISTING: Khai báo bằng function chuẩn để có thể gọi ở bất kỳ đâu
export function handleForceLogout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_display_name');
    localStorage.removeItem('username');
    localStorage.removeItem('user_role'); // Nên xóa cả role
    window.location.href = '/login';
}

// --- INTERCEPTORS ---

client.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

client.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken) {
                try {
                    // 3. SỬA LỖI HARDCODE URL: Dùng biến động theo môi trường
                    const res = await axios.post(`${API_BASE_URL}/token/refresh/`, {
                        refresh: refreshToken
                    });

                    if (res.status === 200) {
                        localStorage.setItem('access_token', res.data.access);
                        client.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`;
                        originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;
                        return client(originalRequest);
                    }
                } catch (refreshError) {
                    console.error("Refresh token hết hạn hoặc không hợp lệ:", refreshError);
                    handleForceLogout();
                }
            } else {
                handleForceLogout();
            }
        }
        return Promise.reject(error);
    }
);

// ==========================================
// CÁC HÀM GỌI API (ĐÃ BỔ SUNG ĐẦY ĐỦ TỪ VIEWS.PY)
// ==========================================

export const login = (username, password) => client.post('/token/', { username, password });

// --- DANH MỤC CƠ BẢN ---
export const fetchTours = () => client.get('/tours/');
export const fetchUsers = () => client.get('/users/');
export const fetchCustomers = () => client.get('/customers/');
export const fetchLocations = () => client.get('/locations/');

export const getExchangeRate = () => client.get('/exchange-rates/USD/');
export const updateExchangeRate = (data) => client.patch('/exchange-rates/USD/', data);

// --- QUẢN LÝ BOOKING ---
export const getAllBookings = () => client.get('/bookings/');
export const getBookingDetail = (code) => client.get(`/bookings/${code}/`);
export const createBooking = (data) => client.post('/bookings/', data);
export const updateBooking = (id, data) => client.patch(`/bookings/${id}/`, data);
export const searchBookings = (query) => client.get(`/bookings/?search=${query}`);
export const searchCustomers = (query) => client.get(`/customers/?search=${query}`);
export const checkBookingExists = (code) => client.get(`/bookings/${code}/`);

// --- ĐIỀU HÀNH & EMAIL ---
export const sendTourOrderEmail = (data) => client.post('/bookings/send_tour_order_email/', data);
export const sendTransportOrderEmail = (data) => client.post('/transports/send_transport_order_email/', data);
export const updateBookingTourStatus = (id, operationStatus) => 
    client.patch(`/booking-tours/${id}/update_status/`, { operation_status: operationStatus });
export const updateBookingRoomStatus = (id, operationStatus) => 
    client.patch(`/booking-rooms/${id}/update_status/`, { operation_status: operationStatus });

// --- TÀI CHÍNH CÔNG NỢ (PAYABLES & PAYMENTS) ---
export const getAllPayables = (params) => client.get('/payables/', { params });
export const createPayable = (formData) => client.post('/payables/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updatePayable = (id, formData) => client.patch(`/payables/${id}/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateBookingPayment = (id, data) => client.patch(`/booking-payments/${id}/`, data);

// --- QUẢN LÝ TÀI KHOẢN TÀI CHÍNH ---
export const fetchAllFinancialAccounts = () => client.get('/financial-accounts/');
export const createFinancialAccount = (data) => client.post('/financial-accounts/', data);
export const updateFinancialAccount = (id, data) => client.patch(`/financial-accounts/${id}/`, data);
export const deleteFinancialAccount = (id) => client.delete(`/financial-accounts/${id}/`);
export const fetchAccountTransactions = (accountId, params) => client.get(`/financial-accounts/${accountId}/transactions/`, { params });

// --- SERVICE PROVIDERS (NCC) ---
export const fetchAllServiceProviders = () => client.get('/service-providers/');
export const fetchTransportProviders = () => client.get('/service-providers/?category=TRANSPORT');
export const fetchHotelProviders = () => client.get('/service-providers/?category=ACCOMMODATION');
export const fetchProvidersByCategory = (categoryCode) => client.get(`/service-providers/?category=${categoryCode}`);
export const createServiceProvider = (data, config = {}) => client.post('/service-providers/', data, config);
export const updateServiceProvider = (id, data, config = {}) => client.patch(`/service-providers/${id}/`, data, config);
export const deleteServiceProvider = (id) => client.delete(`/service-providers/${id}/`);

// --- QUẢN TRỊ HỆ THỐNG (MANAGEMENT) ---
export const getManagementStats = (params) => client.get('/management/performance_stats/', { params });
export const bulkPayPayables = (formData) => client.post('/management/bulk_pay_payables/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const bulkApprovePayables = (data) => client.post('/management/bulk_approve_payables/', data); // MỚI
export const bulkCreateRefunds = (formData) => client.post('/management/bulk_create_refunds/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const syncLiabilityStatus = () => client.post('/management/sync_liability_status/');

// --- TIỆN ÍCH DỌN RÁC (SYSTEM CONTROL) ---
export const scanMissingFiles = () => client.get('/management/scan_missing_files/');
export const scanRedundantData = () => client.get('/management/scan_redundant_data/');
export const cleanupRedundantData = (data) => client.post('/management/cleanup_redundant_data/', data);

// --- QUẢN LÝ TOUR (DB) ---
export const createTour = (data) => client.post('/tours/', data);
export const updateTour = (code, data) => client.patch(`/tours/${code}/`, data);
export const deleteTour = (code) => client.delete(`/tours/${code}/`);

// --- QUẢN LÝ TUYẾN XE (DB) ---
export const fetchTransportRoutes = (params) => client.get('/transport-routes/', { params });
export const createTransportRoute = (data) => client.post('/transport-routes/', data);
export const updateTransportRoute = (code, data) => client.put(`/transport-routes/${code}/`, data);
export const deleteTransportRoute = (code) => client.delete(`/transport-routes/${code}/`);

// --- QUẢN LÝ PHÒNG KHÁCH SẠN (DB) ---
export const fetchHotelRooms = (params) => client.get('/hotel-rooms/', { params });
export const createHotelRoom = (data) => client.post('/hotel-rooms/', data);
export const updateHotelRoom = (code, data) => client.put(`/hotel-rooms/${code}/`, data);
export const deleteHotelRoom = (code) => client.delete(`/hotel-rooms/${code}/`);

// --- CHI PHÍ CHUNG (GENERAL EXPENSES) ---
export const getGeneralExpenses = (params) => client.get('/general-expenses/', { params });
export const createGeneralExpense = (data) => client.post('/general-expenses/', data);
export const updateGeneralExpense = (id, data) => client.patch(`/general-expenses/${id}/`, data);
export const deleteGeneralExpense = (id) => client.delete(`/general-expenses/${id}/`);
export const bulkPayExpenses = (formData) => client.post('/general-expenses/bulk_pay/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const bulkDistributeExpenses = (formData) => client.post('/general-expenses/bulk_distribute/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// --- KẾ TOÁN & LỢI NHUẬN (DISTRIBUTION) ---
export const fetchClosedBookingsForProfit = () => client.get('/bookings/');
export const bulkDistributeBookings = (formData) => client.post('/bookings/bulk_distribute/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const bulkDistributeTransactions = (formData) => client.post('/distribution-sessions/bulk_distribute_transactions/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getDistributionSessions = (params) => client.get('/distribution-sessions/', { params });
export const getDistributionSessionDetail = (id) => client.get(`/distribution-sessions/${id}/`);
export const deleteDistributionSession = (id) => client.delete(`/distribution-sessions/${id}/`);

// --- NHÂN SỰ & PHÂN QUYỀN (HR) ---
export const fetchHRUsers = () => client.get('/human-resources/');
export const saveHRProfile = (data) => client.post('/human-resources/save_hr_profile/', data);

// --- LOG HOẠT ĐỘNG ---
export const fetchActivityLogs = (type, id) => client.get(`/activity-logs/?content_type=${type}&object_id=${id}`);
export const fetchGlobalActivityLogs = (params) => client.get('/activity-logs/', { params });

export default client;